<template>
    <svg
        class="rotate-90 mr-2"
        id="Chevron_-_Médio_-_Ícone"
        data-name="Chevron - Médio - Ícone"
        xmlns="http://www.w3.org/2000/svg"
        width="13.182"
        height="8"
        viewBox="0 0 13.182 8"
    >
        <g id="Chevron" transform="translate(13.182 0) rotate(90)">
            <path
                id="Caminho_10434"
                data-name="Caminho 10434"
                d="M7.788,7.1,1.921,12.97a.724.724,0,0,1-1.025,0l-.684-.684a.724.724,0,0,1,0-1.023l4.65-4.671L.211,1.92A.724.724,0,0,1,.212.9L.9.212a.724.724,0,0,1,1.025,0L7.788,6.079A.725.725,0,0,1,7.788,7.1Z"
                transform="translate(0 0)"
                class="fill-current"
            />
        </g>
    </svg>
</template>
